import { normalizeInboxIdList } from './inboxIdsNormalize';

/**
 * Filtros do gatilho `conversation_created` em `node.data.conversation_filters`.
 *
 * - `inbox_ids`: lista de IDs numéricos de caixas. Vazia = todas as caixas.
 */

export function defaultConversationFilters() {
  return {
    inbox_ids: [],
  };
}

export function normalizeConversationFilters(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...defaultConversationFilters() };
  }
  return {
    inbox_ids: normalizeInboxIdList(raw.inbox_ids),
  };
}
